<template>
    <div class="dropdown dropright border-bottom-item">
        <button class="dropdown-item" v-on:click="menuAnchorageClick()" type="button">
            Calculate Anchorage
        </button>
    </div>
</template>

<script>

import { enterAnchorageMode } from "./AnchorageMode";

export default {
    name: "AnchorageMenu",
    props: ["isEngineerMode"],
    components: {},
    methods: {
        menuAnchorageClick: function () {
            gtag('event', 'View->Calculate Anchorage');
            enterAnchorageMode();
        }
    }
};


</script>

<style scoped></style>